export default class Scraper {
  constructor(obj) {
    if (obj.scraper) {
      this.errors = obj.scraper.errors;
      this.building_website = obj.scraper.building_website;
      this.building_website_meta = obj.scraper.building_website_meta;
      this.property_type = obj.scraper.property_type;
      this.property_type_meta = obj.scraper.property_type_meta;
      this.number_buildings = obj.scraper.number_buildings;
      this.number_buildings_meta = obj.scraper.number_buildings_meta;
      this.number_units = obj.scraper.number_units;
      this.number_units_meta = obj.scraper.number_units_meta;
      this.bed = obj.scraper.bed;
      this.bed_meta = obj.scraper.bed_meta;
      this.bath = obj.scraper.bath;
      this.bath_meta = obj.scraper.bath_meta;
      this.partial_bath = obj.scraper.partial_bath;
      this.partial_bath_meta = obj.scraper.partial_bath_meta;
      this.sqft = obj.scraper.sqft;
      this.sqft_meta = obj.scraper.sqft_meta;
      this.year_built = obj.scraper.year_built;
      this.year_built_meta = obj.scraper.year_built_meta;
      this.number_stories = obj.scraper.number_stories;
      this.number_stories_meta = obj.scraper.number_stories_meta;
      this.description = obj.scraper.description;
      this.description_meta = obj.scraper.description_meta;
      this.building_amenities = obj.scraper.building_amenities;
      this.building_amenities_meta = obj.scraper.building_amenities_meta;
      this.unit_features = obj.scraper.unit_features;
      this.unit_features_meta = obj.scraper.unit_features_meta;
      this.other_amenities = obj.scraper.other_amenities;
      this.other_amenities_meta = obj.scraper.other_amenities_meta;
      this.pet_policy = obj.scraper.pet_policy;
      this.pet_policy_meta = obj.scraper.pet_policy_meta;
      this.management_company = obj.scraper.management_company;
      this.management_company_meta = obj.scraper.management_company_meta;
      this.estimated_value = obj.scraper.estimated_value;
      this.estimated_value_meta = obj.scraper.estimated_value_meta;
      this.estimated_value_per_sqft = obj.scraper.estimated_value_per_sqft;
      this.estimated_rent = obj.scraper.estimated_rent;
      this.estimated_rent_meta = obj.scraper.estimated_rent_meta;
      this.estimated_rent_per_sqft = obj.scraper.estimated_rent_per_sqft;
      this.basement = obj.scraper.basement;
      this.basement_meta = obj.scraper.basement_meta;
      this.last_sold_price = obj.scraper.last_sold_price;
      this.last_sold_price_meta = obj.scraper.last_sold_price_meta;
      this.last_sold_date = obj.scraper.last_sold_date;
      this.last_sold_date_meta = obj.scraper.last_sold_date_meta;
      this.address = obj.scraper.address;
      this.monthly_hoa = obj.scraper.monthly_hoa;
      this.monthly_hoa_meta = obj.scraper.monthly_hoa_meta;
      this.estimated_annual_tax = obj.scraper.estimated_annual_tax;
      this.estimated_annual_tax_meta = obj.scraper.estimated_annual_tax_meta;
      this.lot_size = obj.scraper.lot_size;
      this.lot_size_meta = obj.scraper.lot_size_meta;
      this.roof_type = obj.scraper.roof_type;
      this.roof_type_meta = obj.scraper.roof_type_meta;
      this.exterior_construction = obj.scraper.exterior_construction;
      this.exterior_construction_meta = obj.scraper.exterior_construction_meta;
      this.amenities = obj.scraper.amenities;
      this.walk_score = obj.scraper.walk_score;
      this.walk_score_meta = obj.scraper.walk_score_meta;
      this.transit_score = obj.scraper.transit_score;
      this.transit_score_meta = obj.scraper.transit_score_meta;
      this.schools = obj.scraper.schools;
      this.schools_meta = obj.scraper.schools_meta;
      this.fire_risk = obj.scraper.fire_risk;
      this.fire_risk_meta = obj.scraper.fire_risk_meta;
      this.flood_risk = obj.scraper.flood_risk;
      this.flood_risk_meta = obj.scraper.flood_risk_meta;
      this.heat_risk = obj.scraper.heat_risk;
      this.heat_risk_meta = obj.scraper.heat_risk_meta;
    }
  }
}
